import { createApp } from "vue";
import { SnackbarService, Vue3Snackbar } from "vue3-snackbar";

import App from "./App.vue";
import router from "./router";
import apiPlugin from "./plugins/api";

import "vue3-snackbar/styles";

const app = createApp(App);

app.config.globalProperties.$projectName = window.location.hostname.includes(
    "uzgo"
)
    ? "UzGo"
    : "GeGo";

app.use(router);
app.use(SnackbarService);
app.use(apiPlugin);
app.component("vue3-snackbar", Vue3Snackbar);
app.mount("#app");
